module.exports = __webpack_public_path__ + "static/wojciech_oleksiak@x1-3b4515449d09640e6854705656175470.jpg";